export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const CENTERS = "CENTERS"

export const SPECIALTIES = "SPECIALTIES"
export const STUDENTS = "STUDENTS"
export const MESSAGES = "MESSAGES"
export const OLD_MESSAGES = "OLD_MESSAGES"
export const BRODCAST_MESSAGES = "BRODCAST_MESSAGES"
